module.exports = __webpack_public_path__ + "img/bs_silo_3.bd00c453.png";